import React, { useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Grid  from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import xLogo from "../assests/Logo.png";
import { useNavigate ,Link } from "react-router-dom";
import Modals from "./Modals";

const Header = ({hiddenNavbar, search, setSearch}) => {
  const [input, setInput] = useState("");

  const navigate = useNavigate()

  const handleNavigate = () => {
    navigate("/")
  }
  
  const [dbTimeout, setDBTimeout] = useState(null)
  const debounceSearch = (event, debounceTimeout) => {
    setInput(event.target.value)
    
    if(debounceTimeout){
      clearTimeout(debounceTimeout)
    }
    
    const timeOut = setTimeout(()=>{
      setSearch(event.target.value) 
    }, 500)
    setDBTimeout(timeOut)
  };

  if(hiddenNavbar){
    return (
      <>
        <Grid
          container
          sx={{ backgroundColor: "#282c34", maxWidth: "100%" }}
          alignItems="center"
        >
          <Grid item xs={3} p={2}>
          <Link to={"video"}>  <img src={xLogo} alt="XFlix_logo" onClick={handleNavigate} /></Link>
          </Grid>

          <Grid item xs={6} p={2}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" border={'2px solid #444D56'}>
              <TextField 
                sx={{ input: { color: 'white' } }}
                size="small"
                fullWidth
                placeholder="Search"
                name="search"
                value={input}
                color="close"
                onChange={(e)=>debounceSearch(e, dbTimeout)}
              />

              <Box display={"flex"} justifyContent={"center"} alignItems={"center"}
                sx={{ 
                  width: 60, 
                  height: 35, 
                }}>
                <SearchIcon color={"close"}/>
              </Box>
            </Stack>
          </Grid>

          <Modals />

        </Grid>
      </>
    );
  }

  return (
    <>
      <Grid container sx={{backgroundColor:'#282c34', maxWidth: '100%'}} alignItems="center">
        <Grid item xs={3} p={2}>
          <img src={xLogo} alt="XFlix_logo" onClick={handleNavigate} />
        </Grid>        
      
      </Grid>
    </>
  );
};

export default Header;
